module.exports = __webpack_public_path__ + "static/media/lBanner1.3a9c0bb8.png";